export const LOGIN = "@@authentication/LOGIN";
export const LOGOUT = "@@authentication/LOGOUT";
export const SET_ERROR_LOGIN = "@@authentication/SET_ERROR_LOGIN";
export const SET_PROCESS_VALIDATE_SESSION = "@@authentication/SET_PROCESS_VALIDATE_SESSION";
export const SET_STATE_AUTHENTICATION = "@@authentication/SET_STATE_AUTHENTICATION";
export const RESET_STATE = "@@authentication/RESET_STATE";
